import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { when } from 'mobx';
import { CartWidgetSdk } from './cart';
import { LoyaltyWidgetSdk } from './loyalty';
import { SearchBarWidgetSdk } from './searchBar';

export class WidgetsSdk {
  public cart = new CartWidgetSdk();

  public loyalty = new LoyaltyWidgetSdk();

  public searchBar = new SearchBarWidgetSdk();

  /**
   * @deprecated
   * @param htmlElement
   */
  renderSearchBar(htmlElement: Element): void {
    const SearchBarFrame = React.lazy(() => import('@gamiphy/loyalty-station-desktop/frames/widgets/searchBar/SearchBarFrame'));

    when(() => AppStore.initialized, () => {
      if (AppStore.app.enabled) {
        createRoot(htmlElement).render(
          <React.Suspense fallback={<div />}>
            <SearchBarFrame />
          </React.Suspense>,
        );
      }
    });
  }

  /**
   * @deprecated
   * @param htmlElement
   * @param orderAmount
   */
  renderCheckoutPopup(htmlElement: Element, orderAmount: number): void {
    const CheckoutPopupFrame = React.lazy(() => import('@gamiphy/loyalty-station-desktop/frames/widgets/checkoutPopup/CheckoutPopupFrame'));

    when(() => AppStore.initialized, () => {
      if (AppStore.app.enabled) {
        createRoot(htmlElement).render(
          <React.Suspense fallback={<div />}>
            <CheckoutPopupFrame orderAmount={orderAmount} />
          </React.Suspense>,
        );
      }
    });
  }

  /**
   * @deprecated
   * @param htmlElement
   */
  renderLoyaltyPage(htmlElement: Element): void {
    const LoyaltyPageFrame = React.lazy(() => import('@gamiphy/loyalty-station-desktop/frames/widgets/loyaltyPage/LoyaltyPageFrame'));

    when(() => AppStore.initialized, () => {
      if (AppStore.app.enabled) {
        createRoot(htmlElement).render(
          <React.Suspense fallback={<div />}>
            <LoyaltyPageFrame />
          </React.Suspense>,
        );
      }
    });
  }
}
